let baseUrl = 'https://tce-25jigen.jp/';
let host = location.host;
let Run = ['tce-25jigen.jp', 'https://system.tce-25jigen.jp']; // 本サイトドメインを使って本番か開発かの出し分けを行ってください
let MODD_CART_ID = 'TCET';

$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'contact') {
        Contact();
    }

    // favicon
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = baseUrl + 'favicon.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
});

// プライバシーポリシーのリダイレクト
if (location.href.indexOf('privacy.aspx') != -1) {
    $('body, html').hide();

    location.href = 'https://www.axelentermedia.co.jp/privacy/';
}

// Register
function pageRegister() {
    $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="/v2/help/kiyaku.aspx?ccode=' + MODD_CART_ID + '" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    $('.table_label.col_must').each(function(){
        let $title = $(this);

        if($title.text().indexOf('郵便番号') > -1) {
            $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
        }
    });
}

// MyPage
function MyPage() {
    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');
}

// Contact
function Contact() {
    $('.t_message').each(function () {
        let $title = $(this);

        if($title.text().indexOf('お電話でのお問い合わせ') > -1) {
            $title.hide();
        }
    });
}